import { TokenSmartContractInteraction } from "src/models";
import { Credentials } from "src/models/instantiateClass";
import { MaticNftCreateColelction } from "src/models/modelsMaticNft/MaticNftCreateCollection";
import { MaticNftMint } from "src/models/modelsMaticNft/MaticNftMint";
import { MaticNftVerify } from "src/models/modelsMaticNft/MaticNftVerify";
import { MaticGetTxStatus } from "src/models/modelsMaticSmartContract/maticCheckStatus";
import { MaticGetAbi } from "src/models/modelsMaticSmartContract/maticGetAbi";
import { MaticGetAbiFunctions } from "src/models/modelsMaticSmartContract/maticGetAbiFunctions";
import { MaticTokenCreate } from "src/models/modelsMaticToken/MaticTokenCreate";
import { MaticTokenVerify } from "src/models/modelsMaticToken/MaticTokenVerify";
import { MaticTransferToken } from "src/models/modelsMaticToken/MaticTransferToken";
import { axiosRequest } from "./axiosCore";
import { extractValues } from "./extractValues";

export const maticTransferToken = async (payload: MaticTransferToken, initialize: Credentials) => {
    return await axiosRequest('/matic/token/transfer', payload, initialize);
 }
 
 export const maticTokenCreate = async (payload: MaticTokenCreate, initialize: Credentials) => {
     return await axiosRequest('/matic/token/mint', payload, initialize);
  }
 
  export const maticTokenVerify = async (payload: MaticTokenVerify, initialize: Credentials) => {
     return await axiosRequest('/matic/token/verify', payload, initialize);
  }
 
  export const maticNftCreateColelction = async (payload: MaticNftCreateColelction, initialize: Credentials) => {
    return await axiosRequest('/matic/nft/createCollection', payload, initialize);
 }
 
 export const maticNftMint = async (payload: MaticNftMint, initialize: Credentials) => {
    return await axiosRequest('/matic/nft/mint', payload, initialize);
 }
 
 
 export const maticNftVerify = async (payload: MaticNftVerify, initialize: Credentials) => {
    return await axiosRequest('/matic/nft/verify', payload, initialize);
 }
 
 
 export const maticGetAbi = async (payload: MaticGetAbi, initialize: Credentials) => {
    return await axiosRequest('/matic/smartContract/getAbi', payload, initialize);
 }

 export const maticGetAbiFunctions = async (payload: MaticGetAbiFunctions, initialize: Credentials) => {
   return await axiosRequest('/matic/smartContract/getAbiFunctions', payload, initialize);
}

export const maticGetTxStatus = async (payload: MaticGetTxStatus, initialize: Credentials) => {
   return await axiosRequest('/matic/transactions/status', payload, initialize);
}

export const maticTokenSmartContractInteraction =  async (payload: TokenSmartContractInteraction, initialize: Credentials) => {
   const parameters = extractValues(payload.parameters)
   const modifiedPayload = {
       ...payload,
       parameters
   } 
   return await axiosRequest('/matic/token/buildContractInteraction', modifiedPayload, initialize);
}